// Module
var code = `<footer>
    <div class="footer-content">
        <p class="footer-line">
            <span>SpyneJS</span>: AI-Native Application Structure.
        </p>
        <p class="footer-contact">
            Questions or architectural guidance: <a href="mailto:frank@spynejs.com">frank@spynejs.com</a>
        </p>
    </div>
</footer>
`;
// Exports
module.exports = code;